import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgStoreChosenDuotone24 = function SvgStoreChosenDuotone24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M16.35 16.35h4.05V24h-4.05zm-6.75 0h4.5v4.95H9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 13.2a1.8 1.8 0 0 0 1.8-1.8 1.8 1.8 0 0 0 3.6 0 1.8 1.8 0 0 0 3.6 0 1.8 1.8 0 0 0 3.6 0 1.8 1.8 0 0 0 3.6 0l-1.657-4.143A2 2 0 0 0 20.486 6H9.514a2 2 0 0 0-1.857 1.257L6 11.4a1.8 1.8 0 0 0 1.8 1.8z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 13.2V24h14.4V13.2m-3.6 6.7h.9M6 10.9h18m-14.4.05L10.95 6m9.574 4.95L19.174 6M13.2 10.95 13.65 6m3.15 4.95L16.35 6",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72 0A6.727 6.727 0 0 0 0 6.72a6.728 6.728 0 0 0 6.72 6.72 6.729 6.729 0 0 0 6.72-6.72A6.728 6.728 0 0 0 6.72 0z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m2.88 6.72 2.88 2.4 4.8-5.28",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
};

var StoreChosenDuotone24Svg = SvgStoreChosenDuotone24;

export { StoreChosenDuotone24Svg as default };
//# sourceMappingURL=StoreChosenDuotone24.svg.js.map
